import React from "react";
import { Link } from "react-router-dom";
import styled from 'styled-components';
import MenuItems from "./menuItems";
import { menuItems } from "./menus";

const StyledMenuItems = styled.div`
  position: relative;
  padding: 16px 20px 16px 16px;
  font-size: 16px;
  font-size: 16px;
  cursor: pointer;
  white-space: nowrap;
  color: white;

  &:hover {
    background-color: #04aa6d;
  }
`;

const StyledMenus = styled.div`
	display: flex;
  width: 80%;
  margin: auto;
	font-family: sans-serif;
	color: white;
	align-items: center;
	justify-content: space-between;

`;

const NavbarComponent = () => {

	return (
    <StyledMenus>
      <div style={{display: 'flex'}}>
        <Link style={{ textDecoration: 'none', color: 'white' }} to={'/'}>
          <StyledMenuItems className="menu-items">
                <span style={{marginRight: '8px'}}>Home</span>
          </StyledMenuItems>
        </Link>
        {menuItems.map((menu, index) => {
          const depthLevel = 0;
          return <MenuItems items={menu} key={index} depthLevel={depthLevel} rightSide={false} />;
        })}
      </div>
    </StyledMenus>
	)
}

export default NavbarComponent;